declare var $; // jQuery

class MyProfileController {
	
	public page;
	public useResetPasswordFormFlag: boolean;
	public ssoList;

	// @ngInject
	constructor( private apiService,
				 private observerService, 
				 private $location,
				 private $timeout,
				 private $q				: ng.IQService,
				 private $window
	) {}

	private $onInit = (): void => {
		this.observerService.attach( this.redirectToHome, 'loginSuccess');
		this.observerService.attach( this.onProfileUpdateSuccess, 'updateSuccess' );
		this.observerService.attach( this.onChangePasswordSuccess, 'changePasswordSuccess' );
		this.observerService.attach( this.onPasswordResetSuccess, 'resetPasswordSuccess' );
		this.getUseResetPasswordFormFlag();
		this.apiService.getAllSsoList().then((response)=>{
			this.ssoList = response; 
		})
	}
	
	public redirectToWelcome = () => {
		var redirectIndex = this.$window.location.href.indexOf('redirectTo=');
		
		if(redirectIndex !== -1) return;
		
		this.$window.location = '/welcome';	
	}
	
	public redirectToHome = (args):void =>{
		var redirectIndex = this.$window.location.href.indexOf('redirectTo=');
		if(args.redirectTarget){

			var windowTarget = args.redirectTarget; 
			
			if(window.location.href.split('?').length > 1){
				windowTarget += '?' + window.location.href.split('?')[1];
			}
			
			this.$window.location = windowTarget;
		} else if(redirectIndex === -1) {
			this.$window.location = '/welcome';	
		}
	}
	
	public setPage = ( pageName: string ): void => {
		this.page = pageName;
	}
	
	public onProfileUpdateSuccess = (): void => {
		this.setPage('view');
	}
	
	public onChangePasswordSuccess = (): void => {
		$('#changePasswordModal').modal('hide');
		
		// Clear form data.
		let form = <HTMLFormElement>document.getElementById('changePasswordForm');
		form.reset();
	}
	
	public onPasswordResetSuccess = (): void => {
		this.useResetPasswordFormFlag = false;
		this.setPage('login');
		this.$location.search( 'swprid', null )
	}
	
	public getUseResetPasswordFormFlag = (): void => {
		this.useResetPasswordFormFlag = ( 'undefined' !== typeof this.$location.search().swprid );
	}
	
	public showProfileInfo = (): boolean => {
		let qs = this.$location.search();
		return !qs.hasOwnProperty('redirectTo');
	}
	
}

export { MyProfileController };